import { ISortableTableItem } from '../DataModelerTablesGrid/types';
import {
  ISchemaDataModelFieldsFragment,
  ITableColumnFieldsFragment,
} from '../../../../utils/apollo/graphqlSchema';
import useDataModelerCdwTablePreviewGridModel from './useDataModelerCdwTablePreviewGridModel';
import { PreviewTableHeaderWrapper } from '../DataModelerCommonUI';
import React, { useCallback } from 'react';
import { SecondaryButton } from '../../../../components/Button';
import DataModelerPreviewDataGrid from '../DataModelerPreviewDataGrid';

interface IProps {
  schemaObj: ISchemaDataModelFieldsFragment;
  tableItem: ISortableTableItem;
  loadColumnsError: string | undefined;
  availableColumnsFromServer: ITableColumnFieldsFragment[];
  collapseDerivedColumn: () => void;
}

const DataModelerCdwTablePreviewGrid = ({
  schemaObj,
  tableItem,
  loadColumnsError,
  availableColumnsFromServer,
  collapseDerivedColumn,
}: IProps) => {
  const { loading, previewCachedData, loadPreviewData, resetPreviewData } =
    useDataModelerCdwTablePreviewGridModel({
      schemaObj,
      tableItem,
      availableColumnsFromServer,
    });

  const handlePreviewClick = useCallback(() => {
    collapseDerivedColumn();
    loadPreviewData();
  }, [collapseDerivedColumn, loadPreviewData]);

  if (!loading && !previewCachedData) {
    return (
      <PreviewTableHeaderWrapper>
        <SecondaryButton
          isOutlined={true}
          disabled={!!loadColumnsError}
          onClick={handlePreviewClick}
          trackContext="data modeler"
          trackAction="cdw - preview table values"
        >
          Preview Table Values
        </SecondaryButton>
      </PreviewTableHeaderWrapper>
    );
  }
  return (
    <div id={'cdw-table-preview-wrapper'}>
      <DataModelerPreviewDataGrid
        loading={loading}
        loadPreviewData={loadPreviewData}
        resetPreviewData={resetPreviewData}
        previewCachedData={previewCachedData}
        headerName={'Table'}
        lastColumnIsResult={false}
      />
    </div>
  );
};

export default DataModelerCdwTablePreviewGrid;
